const hasEmoji = function() {
    let context;
    let smile;

    if (!document.createElement('canvas').getContext) return;
    context = document.createElement('canvas').getContext('2d');

    if (typeof context.fillText != 'function') return;
    smile = String.fromCharCode(55357) + String.fromCharCode(56835);

    context.textBaseline = 'top';
    context.font = '32px Arial';
    context.fillText(smile, 0, 0);
    return context.getImageData(16, 16, 1, 1).data[0] !== 0;
}

export default hasEmoji;



// WEBPACK FOOTER //
// ./js/lib/emoji.js